import { useMutation, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { getUserDetails, IloginPayload, loginUser, logoutUser } from "../services/auth";

export interface ILoginResponse {
  access_token: string;
  expires_in: number;
  token_type: string;
  scope: string;
  refresh_token: string;
}

export interface IUserResponse {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  organisation: {
    id: number;
    name: string;
    description: string | null;
    configuration: any | null;
    boundary_type: string;
    geometry: any | null;
  } | null;
  is_active: boolean;
  is_staff: boolean;
  is_superuser: boolean;
  role: string | null;
  permissions: string[];
  groups: any[];
  date_joined: string;
  last_login: string | null;
  fulcrum_api_key: string | null;
  has_fulcrum_api_key: boolean;
  fulcrum_region: string | null;
}

export const useLogin = () => {
  return useMutation<ILoginResponse, Error, IloginPayload>({ mutationFn: loginUser });
};

export const useGetUserDetail = (
  options?: Omit<UseQueryOptions<IUserResponse, Error>, "queryKey" | "queryFn">
): UseQueryResult<IUserResponse, Error> => {
  return useQuery<IUserResponse, Error>({
    queryKey: ["user-detail"],
    queryFn: async () => {
      const response = await getUserDetails();
      return await response.data;
    },
    ...options
  });
};

export const useLogoutMutation = () => {
  return useMutation({ mutationFn: logoutUser });
};
